import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { matchPath } from 'react-router'
import { useLocation } from 'react-router-dom';
import CookiesService from '../../services/cookies/CookiesService'
import { LanguageService } from '../../services/LanguageService'
import { template } from '../../constants/Configs';
import Utils from '../../services/Utils';
import { RoutePath } from '../../constants/SitePaths';

const Cookies = ()=> {
    const [show,setShow] = useState(false);
    const translations = useSelector(state=>state.translations);
    const { pathname } = useLocation()
    const params =  matchPath(pathname,{ path:`/${LanguageService.getSelectedLanguage()}${RoutePath.WIDGET_EDITOR}`})
    const isWidgetPreview  = Utils.isPreviewMode() && params ? true :false

    useEffect(() => {
        translations && setShow(!CookiesService.isCookiesAccapted())
    }, [translations])

    const onClose = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShow(false);
    }

    const onAccept = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShow(false);
        CookiesService.acceptCookies();
    }  

    const getBorderRadius = () => {
        if (template === 1 || template === 3 || template === 2 || template === 4) {
            return { borderRadius: 0 }
        }
        return { borderRadius: '24px 24px 0 0' }
    }
     
    return (
        show && !isWidgetPreview ? <div className={`tb--cookies-wrapper ${template === 5 ? 'l5--cookies-wrapper' : ''}`} style={{ ...getBorderRadius() }}>
            <div className='tb--cookies-logo'><i className='digi_icon-cookies'></i></div>
            <div className='tb--flex tb--align-center tb--cookies-right-col'>
                <div className='tb--cookies-content'>
                    <span className='tb--cookies-text' dangerouslySetInnerHTML={{
                        __html: LanguageService.getTranslation('acceptCookiesNotification', 'general')
                    }}>
                    </span>
                </div>
                <button 
                    className="tb--cookies-btn" 
                    // temporary solution to overwrite bottomsheet 
                        onTouchEnd={onAccept}
                        onClick={onAccept}
                    >
                        {LanguageService.getTranslation('acceptCookiesButton', 'general')}</button>
            </div>
            <div 
                className="tb--modal-close" 
                // temporary solution to overwrite bottomsheet 
                        onClick={onClose}
                        onTouchEnd={onClose}
                >
                    <i className='digi_icon-close'>
                </i></div>
        </div> : <></>
    );
}



export  default Cookies;